import React from 'react'
import { LandingPageImport } from '../Import'
const { ChevronLeft, ChevronRight, GitCommitHorizontal, Card, Slider, TextAnimate, testimonial_img_1, FaStar } = LandingPageImport

const NextArrow = ({ onClick }) => {
    return (
        <div className="testimonials-arrow next" onClick={onClick}>
            <ChevronRight size={30} />
        </div>
    );
};

const PrevArrow = ({ onClick }) => {
    return (
        <div className="testimonials-arrow prev" onClick={onClick}>
            <ChevronLeft size={30} />
        </div>
    );
};

export default function Feedback() {

    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
    };

    return (
        <>
            <div className="feedback padding-100">
                <div className="container">
                    <div className="row">

                        <div className="col-lg-12 m-auto">
                            <div className='hero_title text-center'>
                                <h5 data-aos="fade-left" data-aos-duration="800">
                                    <GitCommitHorizontal className='ms-1 me-1' />
                                    TESTIMONIAL
                                </h5>
                            </div>

                            <div className="hero_sub_title text-center">
                                <h2><TextAnimate text="Feedback from Innovate 2025" /></h2>
                            </div>
                        </div>

                        <div className="col-lg-8 m-auto">
                            <div className="mt-5">
                                <Slider {...settings}>
                                    <div>
                                        <Card className='feedback_card'>
                                            <div className='feedback_content'>
                                                <ul>
                                                    <li><FaStar size={20} className='mb-1' /></li>
                                                    <li><FaStar size={20} className='mb-1' /></li>
                                                    <li><FaStar size={20} className='mb-1' /></li>
                                                    <li><FaStar size={20} className='mb-1' /></li>
                                                    <li><FaStar size={20} className='mb-1' /></li>
                                                </ul>
                                                <p className='main'>
                                                    “The networking opportunities were equally transformative, allowing me to
                                                    connect with like-minded professionals who share a passion for innovation and growth.
                                                    Overall, Innovate 2024 has reinvigorated approach to business & opened doors to new.”
                                                </p>
                                            </div>
                                            <div className="name-area">
                                                <div className="img1">
                                                    <img src={testimonial_img_1} alt="img1" />
                                                </div>
                                                <div className="text">
                                                    <p>Tristian Stubbs</p>
                                                    <span>Founder, Payhawk</span>
                                                </div>
                                            </div>
                                        </Card>
                                    </div>
                                    <div>
                                        <Card className='feedback_card'>
                                            <div className='feedback_content'>
                                                <ul>
                                                    <li><FaStar size={20} className='mb-1' /></li>
                                                    <li><FaStar size={20} className='mb-1' /></li>
                                                    <li><FaStar size={20} className='mb-1' /></li>
                                                    <li><FaStar size={20} className='mb-1' /></li>
                                                    <li><FaStar size={20} className='mb-1' /></li>
                                                </ul>
                                                <p className='main'>
                                                    “The networking opportunities were equally transformative, allowing me to
                                                    connect with like-minded professionals who share a passion for innovation and growth.
                                                    Overall, Innovate 2024 has reinvigorated approach to business & opened doors to new.”
                                                </p>
                                            </div>
                                            <div className="name-area">
                                                <div className="img1">
                                                    <img src={testimonial_img_1} alt="img1" />
                                                </div>
                                                <div className="text">
                                                    <p>Tristian Stubbs</p>
                                                    <span>Founder, Payhawk</span>
                                                </div>
                                            </div>
                                        </Card>
                                    </div>
                                    <div>
                                        <Card className='feedback_card'>
                                            <div className='feedback_content'>
                                                <ul>
                                                    <li><FaStar size={20} className='mb-1' /></li>
                                                    <li><FaStar size={20} className='mb-1' /></li>
                                                    <li><FaStar size={20} className='mb-1' /></li>
                                                    <li><FaStar size={20} className='mb-1' /></li>
                                                    <li><FaStar size={20} className='mb-1' /></li>
                                                </ul>
                                                <p className='main'>
                                                    “The networking opportunities were equally transformative, allowing me to
                                                    connect with like-minded professionals who share a passion for innovation and growth.
                                                    Overall, Innovate 2024 has reinvigorated approach to business & opened doors to new.”
                                                </p>
                                            </div>
                                            <div className="name-area">
                                                <div className="img1">
                                                    <img src={testimonial_img_1} alt="img1" />
                                                </div>
                                                <div className="text">
                                                    <p>Tristian Stubbs</p>
                                                    <span>Founder, Payhawk</span>
                                                </div>
                                            </div>
                                        </Card>
                                    </div>
                                    <div>
                                        <Card className='feedback_card'>
                                            <div className='feedback_content'>
                                                <ul>
                                                    <li><FaStar size={20} className='mb-1' /></li>
                                                    <li><FaStar size={20} className='mb-1' /></li>
                                                    <li><FaStar size={20} className='mb-1' /></li>
                                                    <li><FaStar size={20} className='mb-1' /></li>
                                                    <li><FaStar size={20} className='mb-1' /></li>
                                                </ul>
                                                <p className='main'>
                                                    “The networking opportunities were equally transformative, allowing me to
                                                    connect with like-minded professionals who share a passion for innovation and growth.
                                                    Overall, Innovate 2024 has reinvigorated approach to business & opened doors to new.”
                                                </p>
                                            </div>
                                            <div className="name-area">
                                                <div className="img1">
                                                    <img src={testimonial_img_1} alt="img1" />
                                                </div>
                                                <div className="text">
                                                    <p>Tristian Stubbs</p>
                                                    <span>Founder, Payhawk</span>
                                                </div>
                                            </div>
                                        </Card>
                                    </div>
                                    <div>
                                        <Card className='feedback_card'>
                                            <div className='feedback_content'>
                                                <ul>
                                                    <li><FaStar size={20} className='mb-1' /></li>
                                                    <li><FaStar size={20} className='mb-1' /></li>
                                                    <li><FaStar size={20} className='mb-1' /></li>
                                                    <li><FaStar size={20} className='mb-1' /></li>
                                                    <li><FaStar size={20} className='mb-1' /></li>
                                                </ul>
                                                <p className='main'>
                                                    “The networking opportunities were equally transformative, allowing me to
                                                    connect with like-minded professionals who share a passion for innovation and growth.
                                                    Overall, Innovate 2024 has reinvigorated approach to business & opened doors to new.”
                                                </p>
                                            </div>
                                            <div className="name-area">
                                                <div className="img1">
                                                    <img src={testimonial_img_1} alt="img1" />
                                                </div>
                                                <div className="text">
                                                    <p>Tristian Stubbs</p>
                                                    <span>Founder, Payhawk</span>
                                                </div>
                                            </div>
                                        </Card>
                                    </div>
                                </Slider>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}
